import React, {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {activeAutom, changedFields, initialActions, saveAvailable} from "../../../../recoil-store/recoil-state";
import AppCredential from '../AppCredential/AppCredential';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';
import { CodeEditor } from '../../../FlowConfigurationInputs/CodeEditor/CodeEditor';
import FormControl from "@material-ui/core/FormControl";
import {MenuItem, Select} from "@material-ui/core";
import {CheckIfFlowUpdated} from "../../../../helpers/helper";
import {withStyles} from "@material-ui/core/styles";
import InputBase from "@material-ui/core/InputBase";
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 2,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '0.5px solid #D5D5D5',
        paddingLeft: 5,
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.

    },
}))(InputBase);

function SendCard({ action, variables, setOpenVariable, automId, showAlert, automVersionId }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.MICROSOFT-TEAMS.SEND-CARD.';
    const [automDetail, setAutomDetail] = useRecoilState(activeAutom);
    const [cardType, setCardType] = useState("AdaptiveCard");
    const initialActionsData = useRecoilValue(initialActions);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);

    useEffect(() => {
        if (!action.fields.cardType || !action.fields.cardType.value) {
            action.fields.cardType = { value: "AdaptiveCard", isRequired: true };
            setCardType("AdaptiveCard");
        } else {
            setCardType(action.fields.cardType.value);

        }
    }, [action, variables]);

    function handleCartTypeChange(event) {

        setCardType(event.target.value);
        action.fields.cardType.value = event.target.value;

        const field = initialActionsData[action.id]?.fields.imageType;
        const oldValue = !field ? undefined : field.value;
        CheckIfFlowUpdated('cardType', action, oldValue, event.target.value, setSaveAvailable, setChangeFields, changedFieldsState);
    }

    return (
        <div>
            <AppCredential action={action} />
            <div className="conf-field-container">

                <FieldLabel name={t(label + "CARD-TYPE")} is_required />
                <FormControl variant="outlined" fullWidth style={{ width: "90%" }}>
                    <Select value={cardType} onChange={handleCartTypeChange} input={(cardType) ? null : <BootstrapInput />}>
                        {/* <MenuItem value="tiff">TIFF</MenuItem> */}
                        <MenuItem value="AdaptiveCard">Adaptive Card</MenuItem>
                        <MenuItem value="HeroCard">Hero Card</MenuItem>
                        <MenuItem value="ListCard">List Card</MenuItem>
                        <MenuItem value="ThumbnailCard">Thumbnail Card</MenuItem>
                    </Select>
                </FormControl>
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'CARD-DETAILS')} is_required />
                <CodeEditor action={action} inputName="script" variables={variables} language="powershell"
                    setOpenVariable={setOpenVariable}
                    multiline out_label={label} isRequired hideRequired />
            </div>
            <div className="conf-field-container">
                {t(label + 'RESPONSE')}
                <VariablePicker action={action} inputName="set"
                                variables={variables}
                                disabled={action.fields["set"] && action.fields["set"].value}
                                setOpenVariable={setOpenVariable}
                                styles={{ backgroundColor: "white" }}
                                filter="object"
                                isOutput={true}
                />
            </div>
        </div>
    );
}

export default SendCard;
